import React from 'react';
import { AccessibilityProps, Image, StyleProp, StyleSheet, TouchableOpacity, ViewStyle } from 'react-native';

import { images } from '../assets/images';
import { scale } from '../Styles';

type Props = AccessibilityProps & {
  /** A style to apply to the view. */
  style?: StyleProp<ViewStyle>;
  /** A URL to a photo to render in the view. When no URL is provided, a placeholder will be used. */
  avatarURL?: string;
  /** If press is disabled or not */
  disabled?: boolean;
  /**
   * Called when the avatar is tapped. If provided, the component will be tappable, and will
   * display a "CHANGE" call to action.
   */
  onPress?: () => void;
};

/** A component for displaying a tappable avatar photo. */
export const MNOHSAvatar = (props: Props) => {
  return (
    <TouchableOpacity
      style={[styles.touchable, props.style]}
      disabled={props.disabled}
      onPress={props.onPress}
      activeOpacity={props.onPress ? 0.75 : 1.0}
      accessibilityLabel={props.accessibilityLabel}>
      <Image
        style={[styles.image, styles.imageOnTop]}
        resizeMode={'cover'}
        source={props.avatarURL ? { uri: props.avatarURL } : images.cameraIcon}
      />
      {props.avatarURL && props.onPress ? (
        <Image style={[styles.image, styles.overflow]} source={images.cameraIcon} />
      ) : null}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  touchable: {
    alignItems: 'center',
    position: 'relative',
  },
  changeText: {},
  image: {
    width: scale(200),
    height: scale(200),
    borderRadius: scale(100),
  },
  imageOnTop: {
    zIndex: 1,
  },
  overflow: {
    position: 'absolute',
    top: 0,
    zIndex: 0,
  },
});
